import SrMoreText from "./SrMoreText.vue";

SrMoreText.install = function(Vue) {
  Vue.component(SrMoreText.name, SrMoreText);
};

export default SrMoreText;


// WEBPACK FOOTER //
// ./packages/SrMoreText/index.js